module.exports = __webpack_public_path__ + "static/media/logo.0d15df9c.png";


//////////////////
// WEBPACK FOOTER
// ./src/landing/images/logo.png
// module id = 353
// module chunks = 0